//=include settings/svg-shapes-categories.js
//=include settings/svg-shapes-paths.js
//=include settings/svg-shapes.js
